var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.998,
    height: 17.998,
    rx: 8.99902,
    fill: "#FFE7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 12.7495L5.24805 11.9995L8.24805 8.99945L5.24805 5.99945L5.99805 5.24945L8.99805 8.24945L11.998 5.24945L12.748 5.99945L9.74805 8.99945L12.748 11.9995L11.998 12.7495L8.99805 9.74945L5.99805 12.7495Z",
    fill: "#D43939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.1a0c77c2727259306d22320411e7fbf6.svg";
export { ForwardRef as ReactComponent };